module.exports = {
          srcSet: __webpack_public_path__ + "53efc9a481168f801b3eb9606ee48923-1950.png"+" 1950w",
          images:[ {path: __webpack_public_path__ + "53efc9a481168f801b3eb9606ee48923-1950.png",width: 1950,height: 993}],
          src: __webpack_public_path__ + "53efc9a481168f801b3eb9606ee48923-1950.png",
          toString:function(){return __webpack_public_path__ + "53efc9a481168f801b3eb9606ee48923-1950.png"},
          
          width: 1950,
          height: 993
        }